import { createFileRoute } from '@tanstack/react-router';

import { PostEditPage, socialPostQueryOptions, socialTargetsQueryOptions } from '@/features/social';
import { storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest/posts/$postId')({
  loader: async ({ context, params }) => {
    const [post] = await Promise.all([
      context.queryClient.query({
        ...socialPostQueryOptions(params.storeId, params.postId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({ ...socialTargetsQueryOptions(params.storeId, 'pinterest'), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({ ...storeQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: post.title ?? post.link ?? post.id };
  },
  component: PostEditPage,
});
